import React, { Fragment, useEffect, useState } from 'react';
import Common from '../../../Shared/Common';
import { Container, Row, Col } from 'reactstrap';

import './../Resources/css/block_top.css'
import Block from '../../../Controls/Scafolding/Block';

const Top = (props) => {

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="top" isAlt={true}>

            <Row className="top-inner-lg d-none d-sm-block">
                <Col lg="12">
                </Col>
            </Row>

            <Row className="top-inner-xs d-block d-sm-none">
                <Col lg="12">
                </Col>
            </Row>

            <Row className="top-inner-bottom">
            </Row>
        </Block>
    );
};
export default Top;
